import React from "react";
import "../less/TransferTableAdmin.less";
import CustomDropdown from "../../CustomDropdown";
import DOMPurify from 'utils/sanitize';

function transformedData(backendData) {
  const table = backendData.data[0];

  if (
    !table.columns ||
    !table.rows ||
    !table.cells ||
    !Array.isArray(table.columns) ||
    !Array.isArray(table.rows) ||
    !Array.isArray(table.cells) || 
    table.columns.length === 0 || 
    table.rows.length === 0 || 
    table.cells.length === 0
  ) {
    return;
  }

  const columns = table.columns.slice().sort((a, b) => a.id - b.id);
  const rows = table.rows.slice().sort((a, b) => a.id - b.id);

  const headers = columns.map(col => col.column_name);

  const columnKeys = columns.map((_, i) => (i === 0 ? "range" : `cost${i}`));

  const data = rows.map((row, rowIndex) => {
    const rowData = { id: rowIndex };

    columns.forEach((col, colIndex) => {
      const cell = table.cells.find(c => c.row_id === row.id && c.column_id === col.id);
      const key = columnKeys[colIndex];
      rowData[key] = (cell && cell.cell_value) ? cell.cell_value : "-";
    });

    return rowData;
  });

  return {
    headers,
    columns: columnKeys,
    data
  };
}

export default function template() {
  const { data: backendData, page, isMobile, columnWidth, customWidth, additionToDropdownTitle } = this.props;

  if (!backendData || !Array.isArray(backendData.data) || backendData.data.length === 0) {
    return "";
  }

  const data = transformedData(backendData);
  if (!data || !data.data || data.data.length === 0) {
    return "";
  }

  function getColumnWidth(index) {
    return columnWidth ? columnWidth[index] : (data.columns.length > 2 && index === 1) ? '272px' : '240px';
  }

  const header = isMobile ? (
    data.data.map(row => (
      <div className="header-wrapper" key={row.id}>
        <CustomDropdown
          title={additionToDropdownTitle ? row[data.columns[0]] + " " + additionToDropdownTitle : row[data.columns[0]]}
          classNameDropDown="transfer-table-dropdown"
          classNameItems="transfer-table-dropdown-items"
        >
          {data.headers.map((column, index) =>
            index === 0 ? null : (
              <div key={column} className="mob-table-cell">
                <div
                  className="mob-table-cell-header"
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(column))}}
                />
                <div
                  className="mob-table-cell-value"
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(row[data.columns[index]])}}
                />
              </div>
            )
          )}
        </CustomDropdown>
      </div>
    ))
  ) : (
    <div className="header-wrapper">
      <div className="header-row">
        {data.headers.map((column, index) => {
          const widthSecondCell = getColumnWidth(index);
          return (
            <div
              key={column}
              className="header-row-cell"
              style={customWidth ? undefined : { width: widthSecondCell }}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(column))}}
            />
          );
        })}
      </div>
    </div>
  );

  const bodyRows = isMobile
    ? ""
    : data.data.map(row => (
        <div key={row.id} className="body-row">
          {data.columns.map((column, index) => {
            const widthSecondCell = getColumnWidth(index);
            return (
              <div
                className="body-row-cell"
                key={column}
                style={customWidth ? undefined : { width: widthSecondCell }}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(row[column])}}
              />
            );
          })}
        </div>
      ));

  return (
    <section className={`transfer-table-module ${page}`}>
      {header}
      {bodyRows}
    </section>
  );
}
